import { render, staticRenderFns } from "./YgStudents.vue?vue&type=template&id=22d62f82&"
import script from "./YgStudents.vue?vue&type=script&lang=js&"
export * from "./YgStudents.vue?vue&type=script&lang=js&"
import style0 from "./YgStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports